import React from 'react';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import * as actAdjustment from 'actions/inventory/adjustment';
import { connect } from 'react-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { browserHistory } from 'react-router';
import { isDirty, getFormValues } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import Pusher from 'pusher-js';
import { PUSHER_APP_KEY } from 'api/constants';
import * as action from 'actions';
import styles from './Adjustment.css';
import SummaryAdjustment from './SummaryAdjustment';
import AdjustmentDetail from './AdjustmentDetail';
import List from './List';
import ActionBar from './ActionBar';

class Adjustment extends React.Component {
  render() {
    const { openRightColumn, showLoadingSpinnerPage } = this.props;
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={this._showNoDataToDisplay()}
              title="No Data To Display"
              description=""
              linkLabel="Create Stock Adjustments"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000442823-Cara-Menyesuaikan-Stock-dengan-Adjustment"
            />
            {!showLoadingSpinnerPage && !this._showNoDataToDisplay() && (
              <div className={styles['content-wrapper']}>
                <SummaryAdjustment />
                <List />
              </div>
            )}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <AdjustmentDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
      </PageWrapper>
    );
  }

  componentDidMount() {
    const { dispatch, id } = this.props;
    this.pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = this.pusher.subscribe(`moka-${id}-inventory`);
    dispatch(actAdjustment.pageRequest());
    browserHistory.listenBefore(location => {
      const { isDirtyAdjustment, nextAction } = this.props;
      if (isDirtyAdjustment && !nextAction) {
        dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  componentDidUpdate() {
    const { dispatch, idAsyncJob } = this.props;

    this.channel.bind('library/adjustment/export', data => {
      if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob === data.resource_id &&
        data.type === 'export-done'
      ) {
        dispatch(actAdjustment.adjustmentExportFinished());
        dispatch(action.showLoadingSpinner(false));
        window.location.href = data.url_path;
      } else if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob === data.resource_id &&
        !data.success
      ) {
        dispatch(actAdjustment.adjustmentExportError(data));
      }
    });
  }

  _showNoDataToDisplay = () => {
    const { search, adjustments, ingredientAdjustments } = this.props;
    if (search) {
      const { namespace } = search;
      if (namespace === 'items') {
        return adjustments.length === 0;
      }
      return ingredientAdjustments.length === 0;
    }
    return false;
  };
}

function mapStateToProps(state) {
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const {
    openRightColumn,
    adjustments,
    ingredientAdjustments,
    isExportLoading,
    idAsyncJob,
  } = state.inventory.adjustment;
  const { id } = state.moka.user.business;
  return {
    openRightColumn,
    showLoadingSpinnerPage,
    nextAction: state.confirmAction.nextAction,
    isDirtyAdjustment: isDirty('adjustment')(state),
    adjustments,
    ingredientAdjustments,
    search: getFormValues('search')(state),
    isExportLoading,
    idAsyncJob,
    id,
  };
}

export default connect(mapStateToProps)(Adjustment);
